exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bortBar-cla{height:23.333333rem;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7dea148f","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/dashboard/sortBar/sortBar.vue
// module id = gZVG
// module chunks = 13